import type { AxiosInstance } from 'axios'
import type { Store } from 'redux'
import { useSelector } from 'react-redux'

import { DocumentMeta } from '../components/DocumentMeta'
import { useTranslate } from '../utils/translate'
import Theme from '../components/Theme'

const loader: View.LoaderFn = (api: AxiosInstance, store: Store) => async () => {
  const state = store.getState()
  const isBeyond = Boolean(state.getIn(['shop', 'beyond']))
  const isOrderWithdrawalEnabled = Boolean(state.getIn(['shop', 'userSettings', 'orderWithdrawal', 'active']))

  if (!isBeyond || !isOrderWithdrawalEnabled) {
    throw new Response('Not Found', { status: 404 })
  }

  const { data } = await api.get<{ submittedAt: string }>('/api/v2/orderwithdrawal/confirmation')
  return data
}

OrderWithdrawalConfirmation.loader = loader

export default function OrderWithdrawalConfirmation() {
  const t = useTranslate('shop', 'components.orderWithdrawalConfirmation')
  const shop = useSelector<State, ImmutableMap>((state) => state.get('shop'))

  return (
    <>
      <DocumentMeta
        title={`${t('title')} - ${shop.get('title')}`}
        meta={[{ name: 'robots', content: 'noindex, follow' }]}
      />
      <Theme withLayout currentView="order-withdrawal-confirmation">
        {(renderView, props) => renderView('OrderWithdrawalConfirmation', props)}
      </Theme>
    </>
  )
}
